import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "communityBusinesses" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "communityBusinesses-title" }, "基本资料", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "communityBusinesses-title" }, "往年经营信息", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("保存")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadFile,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

type FormInstance = InstanceType<typeof ElForm>;
interface CompanyBusinessInfo {
  deliverProjectNumber: number;
  deliverRoomNumber: number;
  hardRoomNumber: number;
  roughcastHouseNumber: number;
  communityProjectNumber: number;
  communityRoomNumber: number;
  annualTurnover: number;
  agentTotalCount: number;
  handbagAgentCount: number;
  lastYearProjectNumber: number;
  lastYearProjectSalesAmount: number;
}

interface Company {
  type: number;
  code: string;
  name: string;
  shortName: string;
  licenseNo: string;
  licenseFile: string;
  logo: string;
  brandLogo: string;
  brandBigLogo: string;
  brandName: string;
  contact: string;
  mobile: string;
  tel: string;
  companyAreaIds: string;
  companyAreaIdList: string[];
  companyFace: string;
  remark: string;
  website: string;
  province: string;
  city: string;
  area: string;
  address: string;
  corporateRepresentative: string;
  registeredFund: number;
  industry: string;
  businessCategory: string;
  teamSize: number;
  handbagCertificateLevel: string;
  storefront: string;
  licenseFileFullPath: string;
  logoFullPath: string;
  brandLogoFullPath: string;
  brandBigLogoFullPath: string;
  areaId: string;
  companyBusinessInfo: CompanyBusinessInfo;
  isPublic: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(true);

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleEdit = () => {
  isEdit.value = false;
};
const handleSub = () => {
  isEdit.value = true;
};

const communityBusinessesFormRef = ref<FormInstance>();

const companyBusinessInfoValue: CompanyBusinessInfo = {
  deliverProjectNumber: 0,
  deliverRoomNumber: 0,
  hardRoomNumber: 0,
  roughcastHouseNumber: 0,
  communityProjectNumber: 0,
  communityRoomNumber: 0,
  annualTurnover: 0,
  agentTotalCount: 0,
  handbagAgentCount: 0,
  lastYearProjectNumber: 0,
  lastYearProjectSalesAmount: 0,
};

const company: Company = {
  type: 3,
  code: "",
  name: "",
  shortName: "",
  licenseNo: "",
  licenseFile: "",
  logo: "",
  brandLogo: "",
  brandBigLogo: "",
  brandName: "",
  contact: "",
  mobile: "",
  tel: "",
  companyAreaIds: "",
  companyAreaIdList: [],
  companyFace: "",
  remark: "",
  website: "",
  province: "",
  city: "",
  area: "",
  address: "",
  corporateRepresentative: "",
  registeredFund: 0,
  industry: "",
  businessCategory: "",
  teamSize: 0,
  handbagCertificateLevel: "",
  storefront: "",
  licenseFileFullPath: "",
  logoFullPath: "",
  brandLogoFullPath: "",
  brandBigLogoFullPath: "",
  areaId: "",
  companyBusinessInfo: companyBusinessInfoValue,
  isPublic: "",
};

const ustore = useStore();
const bindData = reactive({
  communityBusinessesForm: company,
  companyAreaOptions: [],
});

const handleLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.communityBusinessesForm.logo = response.result;
  bindData.communityBusinessesForm.logoFullPath = URL.createObjectURL(file.raw);
};

const handleBrandLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.communityBusinessesForm.brandLogo = response.result;
  bindData.communityBusinessesForm.brandLogoFullPath = URL.createObjectURL(
    file.raw
  );
};

const handleBrandBigLogoSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.communityBusinessesForm.brandBigLogo = response.result;
  bindData.communityBusinessesForm.brandBigLogoFullPath = URL.createObjectURL(
    file.raw
  );
};

const handleLicenseFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.communityBusinessesForm.licenseFile = response.result;
  bindData.communityBusinessesForm.licenseFileFullPath = URL.createObjectURL(
    file.raw
  );
};

const loadData = () => {
  store.dispatch("companyModule/listCompanyArea").then(
    (data) => {
      //成功
      bindData.companyAreaOptions = data.result;
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => {},
      });
    }
  );
  store.dispatch("companyModule/getCompany", {}).then(
    (data) => {
      //成功
      bindData.communityBusinessesForm = data.result;
      bindAreaData(bindData.communityBusinessesForm.area);
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => {},
      });
    }
  );
};

loadData();

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写企业编码"));
  } else {
    callback();
  }
};

const communityBusinessesRules = reactive({
  code: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  name: [{ required: true, message: "请填写企业名称", trigger: "blur" }],
});

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    var provinceId = value[0];
    var provinceName = tool.areaCodeToText.get(provinceId);
    if (provinceName != undefined) {
      bindData.communityBusinessesForm.province = provinceName;
    }
    var cityId = value[1];
    var cityName = tool.areaCodeToText.get(cityId);
    if (cityName != undefined) {
      bindData.communityBusinessesForm.city = cityName;
    }
    bindData.communityBusinessesForm.areaId = value[2];
    var areaName = tool.areaCodeToText.get(
      bindData.communityBusinessesForm.areaId
    );
    if (areaName != undefined) {
      bindData.communityBusinessesForm.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  if (areaName && areaName.length > 0) {
    var areaValue = tool.areaTextToCode.get(areaName);
    if (areaValue != undefined) {
      bindData.communityBusinessesForm.areaId = areaValue;
    }
  }
};

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch(
          "companyModule/updateCompany",
          bindData.communityBusinessesForm
        )
        .then(
          (data) => {
            //成功
            ElMessage.success("保存成功.");
            isEdit.value = true;
            loadData();
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => {},
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, {
      model: _unref(bindData).communityBusinessesForm,
      ref_key: "communityBusinessesFormRef",
      ref: communityBusinessesFormRef,
      rules: _unref(communityBusinessesRules),
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "企业名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).communityBusinessesForm.name) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业编码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).communityBusinessesForm.code) = $event)),
              readonly: true,
              "input-style": [{background:'#f5f7fa'},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业简称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.shortName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).communityBusinessesForm.shortName) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业logo" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", _unref(bindData).communityBusinessesForm.logo && 'cur-uploader']),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleLogoSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).communityBusinessesForm.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).communityBusinessesForm.logoFullPath,
                          class: "avatar"
                        }, null, 8, _hoisted_3))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            (isEdit.value == false)
                              ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "经营品牌" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.brandName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).communityBusinessesForm.brandName) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "经营品牌Logo" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", 
              _unref(bindData).communityBusinessesForm.brandLogo && 'cur-uploader'
            ]),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleBrandLogoSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).communityBusinessesForm.brandLogo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).communityBusinessesForm.brandLogoFullPath,
                          class: "avatar"
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            (isEdit.value == false)
                              ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "经营品牌形象大图" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", 
              _unref(bindData).communityBusinessesForm.brandBigLogo && 'cur-uploader'
            ]),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleBrandBigLogoSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).communityBusinessesForm.brandBigLogo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).communityBusinessesForm.brandBigLogoFullPath,
                          class: "avatar"
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            (isEdit.value == false)
                              ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业官网" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.website,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).communityBusinessesForm.website) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业地区" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).communityBusinessesForm.areaId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).communityBusinessesForm.areaId) = $event)),
              disabled: isEdit.value
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "详细地址" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              readonly: isEdit.value,
              modelValue: _unref(bindData).communityBusinessesForm.address,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).communityBusinessesForm.address) = $event)),
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'218px'}]
            }, null, 8, ["readonly", "modelValue", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "营业执照" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", 
              _unref(bindData).communityBusinessesForm.licenseFile && 'cur-uploader'
            ]),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleLicenseFileSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).communityBusinessesForm.licenseFile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).communityBusinessesForm.licenseFileFullPath,
                          class: "avatar"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            (isEdit.value == false)
                              ? (_openBlock(), _createBlock(_unref(Plus), { key: 0 }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "企业信用代码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.licenseNo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).communityBusinessesForm.licenseNo) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "法人代表" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.corporateRepresentative,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).communityBusinessesForm.corporateRepresentative) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "注册资金" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.registeredFund,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).communityBusinessesForm.registeredFund) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "联系人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.contact,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(bindData).communityBusinessesForm.contact) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "联系人手机号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.mobile,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(bindData).communityBusinessesForm.mobile) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "固定电话" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.tel,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).communityBusinessesForm.tel) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "是否公开联系信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(bindData).communityBusinessesForm.isPublic,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(bindData).communityBusinessesForm.isPublic) = $event)),
              disabled: isEdit.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "Y" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "N" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "公司介绍" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')}],
              modelValue: _unref(bindData).communityBusinessesForm.remark,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(bindData).communityBusinessesForm.remark) = $event)),
              type: "textarea",
              autosize: { minRows: 4, maxRows: 8 },
              autocomplete: "off"
            }, null, 8, ["disabled", "input-style", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "经营品类" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.businessCategory,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(bindData).communityBusinessesForm.businessCategory) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "团队人数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.teamSize,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(bindData).communityBusinessesForm.teamSize) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "拎包证书等级" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).communityBusinessesForm.handbagCertificateLevel,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(bindData).communityBusinessesForm.handbagCertificateLevel) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'300px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "店面" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')}],
              modelValue: _unref(bindData).communityBusinessesForm.storefront,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(bindData).communityBusinessesForm.storefront) = $event)),
              type: "textarea",
              autosize: { minRows: 4, maxRows: 8 },
              autocomplete: "off"
            }, null, 8, ["readonly", "input-style", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _hoisted_10,
    _createVNode(_component_el_form, { "label-width": "200px" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "年度营业额" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).communityBusinessesForm.companyBusinessInfo.annualTurnover
          ,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((
            _unref(bindData).communityBusinessesForm.companyBusinessInfo.annualTurnover
          ) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "上年拎包进驻项目数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).communityBusinessesForm.companyBusinessInfo
              .lastYearProjectNumber
          ,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
            _unref(bindData).communityBusinessesForm.companyBusinessInfo
              .lastYearProjectNumber
          ) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "上年项目户均销售额" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: 
            _unref(bindData).communityBusinessesForm.companyBusinessInfo
              .lastYearProjectSalesAmount
          ,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
            _unref(bindData).communityBusinessesForm.companyBusinessInfo
              .lastYearProjectSalesAmount
          ) = $event)),
              readonly: isEdit.value,
              "input-style": [{background:(isEdit.value===true?'#f5f7fa':'')},{width:'100px'}],
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "readonly", "input-style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, { class: "communityBusinesses-btn" }, {
      default: _withCtx(() => [
        (isEdit.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              onClick: handleEdit
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isEdit.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              type: "primary",
              size: "large",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (submitForm(communityBusinessesFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})